import naja from "naja";

class SocialExtension {

	constructor(naja) {
		naja.addEventListener('init', () => {
			this.initFbShareButtons(document);
			this.initTwitterShareButtons(document);
			this.initLinkedinShareButtons(document);
			this.initEmailShareButtons(document);
		});

		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			this.initFbShareButtons(event.snippet);
			this.initTwitterShareButtons(event.snippet);
			this.initLinkedinShareButtons(event.snippet);
			this.initEmailShareButtons(event.snippet);
		});
	}



	initFbShareButtons(block) {
		const elements = block.querySelectorAll('a[fb-share]');
		elements.forEach((elem) => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let url = elem.getAttribute('href');
				let text = elem.getAttribute('fb-share');
				let win = window.open('https://www.facebook.com/sharer/sharer.php?u=' + url + '&quote=' + text, 'ShareOnFacebook', this.getWindowOptions());
				win.opener = null;
			});
		});
	}

	initTwitterShareButtons(block) {
		const elements = block.querySelectorAll('a[twitter-share]');
		elements.forEach((elem) => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let url = elem.getAttribute('href');
				let text = elem.getAttribute('twitter-share');
				let win = window.open('https://twitter.com/intent/tweet?url=' + url + '&text=' + text, 'ShareOnTwitter', this.getWindowOptions());
				win.opener = null;
			});
		});
	}

	initLinkedinShareButtons(block) {
		const elements = block.querySelectorAll('a[linkedin-share]');
		elements.forEach((elem) => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let url = elem.getAttribute('href');
				let text = elem.getAttribute('linkedin-share');
				let win = window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + url + '&quote=' + text, 'ShareOnLinkedin', this.getWindowOptions());
				win.opener = null;
			});
		});
	}

	initEmailShareButtons(block) {
		const elements = block.querySelectorAll('a[email-share]');
		elements.forEach((elem) => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				const email = elem.dataset['emailTo'] || '';
				const subject = elem.dataset['emailSubject'] || '';
				const emailBody = elem.dataset['emailBody'] || elem.href;
				let win = window.open("mailto:" + email + "?subject=" + subject + "&body=" + emailBody, 'ShareByEmail', this.getWindowOptions());
				win.opener = null;
			});
		});
	}

	getWindowOptions() {
		let width = 500;
		let height = 350;
		let left = (window.innerWidth / 2) - (width / 2);
		let top = (window.innerHeight / 2) - (height / 2);

		return [
			'resizable,scrollbars,status',
			'height=' + height,
			'width=' + width,
			'left=' + left,
			'top=' + top,
		].join();
	}
}

naja.registerExtension(SocialExtension);